import React from 'react';
import { Table } from 'react-bootstrap';

import ResultIcon from '../../ResultIcon';
import FormattedPrice from '../../../General/FormattedPrice';

import useGetFaxInfo from '../../../../Hook/Validator/UseGetFaxInfo';

const Specifications: React.FC = () => {
    const faxInfo = useGetFaxInfo();

    if (faxInfo === null) {
        return null;
    }

    return (
        <>
            <h3>Lening</h3>
            <Table className="mortgage-properties__specifications summary" borderless={true}>
                <thead>
                    <tr>
                        <th />
                        <th />
                        <th />
                        <th>Meer/minder</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td />
                        <td>Gevraagde lening</td>
                        <td>
                            <FormattedPrice price={faxInfo.lening} />
                        </td>
                        <td />
                    </tr>
                    <tr>
                        <td>
                            <ResultIcon active={true} color={faxInfo.ltiVoldoet} />
                        </td>
                        <td>O.b.v. inkomen/lasten</td>
                        <td>
                            <FormattedPrice price={faxInfo.lti} />
                        </td>
                        <td>
                            <FormattedPrice price={faxInfo.ltiIndicatie} color={faxInfo.ltiVoldoet} />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <ResultIcon active={true} color={faxInfo.ltvVoldoet} />
                        </td>
                        <td>O.b.v. onderpand/lening</td>
                        <td>
                            <FormattedPrice price={faxInfo.ltv} />
                        </td>
                        <td>
                            <FormattedPrice price={faxInfo.ltvIndicatie} color={faxInfo.ltvVoldoet} />
                        </td>
                    </tr>
                </tbody>
            </Table>
        </>
    );
};

export default Specifications;
